"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMemberOfGroupSet = isMemberOfGroupSet;
exports.canPunishUser = canPunishUser;
exports.canApplyFullBan = canApplyFullBan;
exports.canPickWarnLevel = canPickWarnLevel;
exports.canViewHiddenTopicReaders = canViewHiddenTopicReaders;
exports.canChangeOtherUserLogin = canChangeOtherUserLogin;
exports.canEditOtherUserProfile = canEditOtherUserProfile;
exports.canReportTicket = canReportTicket;
exports.canModerateTicket = canModerateTicket;
exports.canShowEditMarkInEditor = canShowEditMarkInEditor;
exports.canAccessStaffSettings = canAccessStaffSettings;
exports.isBbcodeStaffGroup = isBbcodeStaffGroup;
const groups_1 = require("./groups");
function isMemberOfGroupSet(groupId, groups) {
    return groupId != null && groups.has(groupId);
}
/** Профиль: пункт «Наказать» / заметки (`canPunishUser`). */
function canPunishUser(moderatorGroupId) {
    return isMemberOfGroupSet(moderatorGroupId, groups_1.PUNISH_MENU_GROUPS);
}
/** Диалог наказания: полный бан и расширенные часы RO/бан. */
function canApplyFullBan(moderatorGroupId) {
    return isMemberOfGroupSet(moderatorGroupId, groups_1.SUPER_MOD_GROUPS);
}
/** Шаблоны наказания: выбор уровня warn, если сервер не запретил (`uiFlags & 32`). */
function canPickWarnLevel(uiFlags, moderatorGroupId) {
    return (uiFlags & 32) === 0 || canApplyFullBan(moderatorGroupId);
}
/** «Кто читает тему»: показывать скрытых читателей (`*`). */
function canViewHiddenTopicReaders(viewerGroupId) {
    return isMemberOfGroupSet(viewerGroupId, groups_1.WHO_READS_STAFF_GROUPS);
}
/** Чужой профиль: смена логина (только admin/super). */
function canChangeOtherUserLogin(moderatorGroupId) {
    return isMemberOfGroupSet(moderatorGroupId, groups_1.CHANGE_LOGIN_GROUPS);
}
/** Чужой профиль: редактирование полей. */
function canEditOtherUserProfile(moderatorGroupId) {
    return isMemberOfGroupSet(moderatorGroupId, groups_1.EDIT_PROFILE_OTHERS_GROUPS);
}
/** Тикет: пожаловаться (если зритель не автор тикета). */
function canReportTicket(viewerGroupId) {
    return isMemberOfGroupSet(viewerGroupId, groups_1.TICKET_REPORT_GROUPS);
}
/** Тикет: отмена, восстановление, «…и наказать». */
function canModerateTicket(viewerGroupId) {
    return isMemberOfGroupSet(viewerGroupId, groups_1.TICKET_MOD_GROUPS);
}
/** Редактор поста: чекбокс «Показывать отметку». */
function canShowEditMarkInEditor(editorGroupId) {
    return isMemberOfGroupSet(editorGroupId, groups_1.EDIT_MARK_GROUPS);
}
/** Настройки: staff-only пункты (`I0` #25 и аналоги). */
function canAccessStaffSettings(viewerGroupId) {
    return isMemberOfGroupSet(viewerGroupId, groups_1.SETTINGS_STAFF_GROUPS);
}
/** BBCode `[hide]`: обход ограничений по числу постов. */
function isBbcodeStaffGroup(groupId) {
    return isMemberOfGroupSet(groupId, groups_1.BBCODE_HIDE_STAFF_GROUPS);
}
